import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Images from "../../assests/Images";
import { useMutation, useQuery } from "react-query";
import { productData } from "../globalApi/Api";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PopupModel from "../popupmodel/PopupModel";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import moment from "moment";
const ProductReport = () => {


    const navigate = useNavigate();
    const {
        control,
        watch,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [searchTerm, setSearchTerm] = useState("");

    const [selectedRows, setSelectedRows] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const fromDate = watch("fromDate");
    const toDate = watch("toDate");


    // GET API START
    const { data, isLoading, isError, refetch } = useQuery(
        "productData",
        productData,
        {
            refetchOnWindowFocus: false,
        }
    );

    let details = (data && data?.data) || [];

    // Filter By search

    const filteredDetails = details?.filter((item) => {
        const lowerSearch = searchTerm?.toLowerCase() || "";

        const nameMatch =
            !lowerSearch ||
            item?.productNameEnglish?.toLowerCase().includes(lowerSearch);

        const status = watch("status")?.toUpperCase();
        const stock = item?.stock?.toUpperCase();

        const statusMatch =
            !status ||
            stock === status ||
            (status === "OUT OF STOCK" && Number(item?.quantity) === 0);

        // Convert selected range to timestamps
        const from = fromDate ? new Date(fromDate).setHours(0, 0, 0, 0) : null;
        const to = toDate ? new Date(toDate).setHours(23, 59, 59, 999) : null;

        // Parse item dates
        const manufacturing = item?.manufacturingDate
            ? new Date(item?.manufacturingDate).getTime()
            : null;

        const expiry = item?.expiryDate
            ? new Date(item?.expiryDate).getTime()
            : null;

        // Date match: either date falls inside the selected range
        const dateMatch =
            (!from || !to) ||
            ((manufacturing && manufacturing >= from && manufacturing <= to) ||
                (expiry && expiry >= from && expiry <= to));

        return nameMatch && statusMatch && dateMatch;
    });

    // Dashboard Report
    let overallproduct = filteredDetails && filteredDetails?.length;
    const availableCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.stock?.toLowerCase() === "available"
        ).length;
    const outStockCount =
        filteredDetails?.filter(
            (item) =>
                item?.stock?.toLowerCase() === "out of stock" || Number(item?.quantity) === 0
        ).length || 0;



    // Download Excel
    const downloadExcel = () => {
        // Define headers
        const headers = [
            "S.NO",
            "PRODUCT NAME",
            "UNIT PRICE",
            "QUANTITY",
            "QUANTITY TYPE",
            "STOCK STATUS",
            "MANUFACTURING DATE",
            "EXPIRY DATE",
        ];

        // Map data to match the headers order
        const formattedData =
            filteredDetails &&
            filteredDetails?.map((item, index) => ({
                "S.NO": index + 1,
                "PRODUCT NAME": item?.productNameEnglish || "",
                "UNIT PRICE": item?.unitPrice || "",
                QUANTITY: item?.quantity || "",
                "QUANTITY TYPE": item?.quantityType || "",
                "STOCK STATUS": item?.stock || "",
                "MANUFACTURING DATE": item?.manufacturingDate ? moment(item?.manufacturingDate).format("DD-MM-YYYY") : "",
                "EXPIRY DATE": item?.expiryDate ? moment(item?.expiryDate).format("DD-MM-YYYY") : "",
            }));

        // Create a new workbook and a worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file and trigger download
        XLSX.writeFile(wb, "View Product.xlsx");
    };

    return (
        <>

            <div className="view_form_block">
                <div className="view_form_sub_block">
                    {/* DASHBOARD */}
                    <div className="row my-3 d-flex justify-content-center">
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 dashborad-card-block --first-block">
                            <span className="dashboard-heading" style={{ color: "blue" }}>
                                Overall
                            </span>
                            <span className="dashboard-value" style={{ color: "#1E3A8A" }}>{overallproduct || 0}</span>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 dashborad-card-block">
                            <span className="dashboard-heading" style={{ color: "green" }}>
                                Available
                            </span>
                            <span className="dashboard-value" style={{ color: "#047857" }}>
                                {availableCount || 0}
                            </span>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 dashborad-card-block --last-block">
                            <span className="dashboard-heading" style={{ color: "red" }}>
                                Out Of Stock
                            </span>
                            <span className="dashboard-value" style={{ color: "#B91C1C" }}>
                                {outStockCount || 0}
                            </span>
                        </div>
                    </div>

                    <div className="row my-3">
                        <div className="col-lg-12 d-flex justify-content-center align-items-center gap-3">
                            <Controller
                                control={control}
                                name="fromDate"
                                render={({ field }) => (
                                    <DatePicker
                                        {...field}
                                        selected={field.value}
                                        onChange={field.onChange}
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select From Date"
                                        maxDate={new Date()}
                                        className="filter_date_picker"
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="toDate"
                                render={({ field }) => (
                                    <DatePicker
                                        {...field}
                                        selected={field.value}
                                        onChange={field.onChange}
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select To Date"
                                        minDate={fromDate}
                                        maxDate={new Date()}
                                        className="filter_date_picker"
                                    />
                                )}
                            />
                        </div>
                    </div>

                    {/* Filter and Search */}
                    <div className="row px-1 d-flex justify-content-between">
                        <div className="col-12 col-md-3">
                            <input
                                type="search"
                                className="view_table_search"
                                placeholder="Search by product Name"
                                title="Search by product Name"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-9 d-flex align-items-center justify-content-end gap-2">
                            <Controller
                                name="status"
                                control={control}
                                render={({ field }) => (
                                    <select {...field} className="view-table-status">
                                        <option value="">STOCK STATUS</option>
                                        <option value="AVAILABLE">AVAILABLE</option>
                                        <option value="OUT OF STOCK">OUT OF STOCK</option>
                                    </select>
                                )}
                            />

                            {/* Download Button */}
                            <div
                                className="download_btn_block_purchase d-flex align-items-center"
                                onClick={() => {
                                    downloadExcel();
                                }}
                            >
                                <div className="download_image_block">
                                    <img
                                        src={Images?.downloadIcon}
                                        className="image_icon"
                                        alt="no-image"
                                    />
                                </div>
                                <button className="download_btn">DOWNLOAD</button>
                            </div>


                        </div>
                    </div>
                    <div className="row px-3 my-3">
                        <div className="col-lg-12 view_table_section">
                            <div className="table-responsive view_table_block">
                                <table className="table">
                                    <thead>
                                        <tr>

                                            <th className="view-table-heading">PRODUCT ID</th>
                                            <th className="view-table-heading">PRODUCT NAME</th>
                                            <th className="view-table-heading">UNIT PRICE</th>
                                            <th className="view-table-heading">QUANTITY</th>
                                            <th className="view-table-heading">QUANTITY TYPE</th>
                                            <th className="view-table-heading">STOCK STATUS</th>
                                            <th className="view-table-heading">MANUFACTURING DATE</th>
                                            <th className="view-table-heading">EXPIRY DATE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            <>
                                                <h5 className="my-3">L O A D I N G . . .</h5>
                                            </>
                                        ) : filteredDetails?.length > 0 ? (
                                            <>
                                                {filteredDetails?.map((data, i) => {
                                                    return (
                                                        <>
                                                            <tr
                                                                key={i}

                                                            >

                                                                <td className="view-table-data">
                                                                    {data?.productId || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.productNameEnglish || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.unitPrice || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.quantity}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.quantityType || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.quantity == 0 ? "Out Of Stock" : data?.stock || "-"}

                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.manufacturingDate ? moment(data?.manufacturingDate).format("DD-MM-YYYY") : ""}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.expiryDate ? moment(data?.expiryDate).format("DD-MM-YYYY") : ""}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                <h6>No Record Founds</h6>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductReport